module.exports = __webpack_public_path__ + "static/media/icon-manage-class-class.65df50e9.svg";